import axios from '../../plugins/axios';

/**

 * @param {Object} data - ÐÐ°Ð½Ð½ÑÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ
 * @param {number} data.CarId - ID Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ
 * @param {string} data.JuridicalName - ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ ÑÑ. Ð»Ð¸ÑÐ°
 * @param {string} data.JuridicalDirectorName - Ð¤ÐÐ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ°
 * @param {string} data.CompanyDetails - Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸
 * @param {string} data.ContractNumber - ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°
 * @param {string} data.RepairWorkList - Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÐ°Ð±Ð¾Ñ
 * @returns {Promise<Object>}
 */
export async function createBuyer(data) {
  const formData = new FormData();
  formData.append('json', JSON.stringify(data));

  const response = await axios.post(
    '/api/crm/cars/createBuyer', formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    }
  );
  return response.data;
} 